
import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getProductTypeRequest, getProductTypeRequestError, getProductTypeRequestSuccess } from "../../slices/Supplier/GetProductTypeSlice";


export const GetProductTypeApi = (data) => async (dispatch) => {

    try {
        dispatch(getProductTypeRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.getProductTypeRegister,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getProductTypeRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getProductTypeRequestError(_error));
            });
    } catch (error) {
    }
};
